import type { ReactNode } from 'react';

export const symbol_nearby_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M869.5-458q-4.5 11-12.5 19l-97 97q-11 11-27 11t-27-11q-11-11-11-27t11-27l85-85-313-313-85 85q-11 11-27 10.5T339-710q-11-11-11-27t11-27l98-98q8-8 19.5-12t22.5-4q12 0 22.5 4t18.5 12l337 338q9 8 13 19.5t4 23.5q0 12-4.5 23ZM648-230 521-102q-8 8-19 12t-23 4q-12 0-23.5-4T436-102L99-439q-8-8-12-19.5T83-482q0-12 4-23t12-19l127-127L79-799q-9-9-9-21t9-21q9-9 21-9t21 9l722 722q9 9 9 21t-9 21q-9 9-21 9t-21-9L648-230ZM165-481l313 313 115-115-45-45-49 49q-9 9-21 9t-21-9L276-460q-9-9-9-21t9-21l49-49-45-45-115 115Zm503 33q-14 14-33.5 14T601-448L444-604q-14-14-13.5-33t14.5-33q14-14 33.5-14t33.5 14l156 156q14 14 14 33t-14 33Z"
		/>
	</svg>
);
